<template>
	<section class="header">
		<div class="container">
			<div class="row">
				<div class="col-12">
					<div class="header__wrapper">
						<a @click="$router.go(-1)" class="header__back"><img src="/static/img/arrow.svg" alt=""> <span>{{ $t("back") }}</span></a>
						<a :href="`${url}api/events/${event.id}/pdf/`" class="header__download header__download--desktop"><img src="/static/img/download.svg" alt="">{{$t('pdf')}}<span
							class="header__download--big">  PDF</span></a>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-sm 12 col-md-7">
					<h3 class="header__headline">{{event.name}}</h3>
					<span class="header__rank">{{event.rank}} <span class="header__rank--regular">{{$t('event.rank')}}</span></span>
				</div>
				<div class="hidden-md col-5">
					<div class="info">
						<!--<time class="info__date">{{event.date}} <span class="info__date info__date&#45;&#45;small">/ 2018</span></time>-->
						<time class="info__date">{{event.date}}</time>
						<h5 class="info__headline">{{$t('event.deadline')}}</h5>
						<div class="info__divider"></div>
						<!--<time class="info__deadline">11 December <span class="info__date info__date&#45;&#45;small">/ 2018</span></time>-->
						<time class="info__deadline">{{event.application_deadline}}</time>
						<div class="info__buttons">
							<div v-if="$store.state.user.isLogged" @click="addFavEvent(event)" class="info__btn">
								<span v-if="!fav">{{$t('event.fav')}}</span>
								<span v-if="fav">{{$t('event.remove')}}</span>
								<img src="/static/img/star-white.svg" alt="">
							</div>
							<router-link v-if="!$store.state.user.isLogged" :to="{name: 'CreateAccount'}"
										 class="info__btn">
								<span>{{$t('event.fav')}}</span>
								<img src="/static/img/star-white.svg" alt="">
							</router-link>
							<a :href="event.application_url" class="info__btn info__btn--gold">{{$t('event.apply')}}</a>
							<a href="https://www.booking.com/" class="info__btn info__btn--blue">{{$t('event.hotel')}} Booking<span>.com</span></a>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="info info--mobile">
			<!--<time class="info__date">{{event.date}} <span class="info__date info__date&#45;&#45;small">/ 2018</span></time>-->
			<time class="info__date">{{event.date}}</time>
			<h5 class="info__headline">{{$t('event.deadline')}}</h5>
			<div class="info__divider"></div>
			<!--<time class="info__deadline">11 December <span class="info__date info__date&#45;&#45;small">/ 2018</span></time>-->
			<time class="info__deadline">{{event.application_deadline}}</time>
			<div class="info__buttons">
				<div v-if="$store.state.user.isLogged" @click="addFavEvent(event)" class="info__btn">
					<span v-if="!fav">{{$t('event.fav')}}</span>
					<span v-if="fav">{{$t('event.remove')}}</span>
					<img src="/static/img/star-white.svg" alt="">
				</div>
				<router-link v-if="!$store.state.user.isLogged" :to="{name: 'CreateAccount'}"
							 class="info__btn">
					<span>Add to My Events</span>
					<img src="/static/img/star-white.svg" alt="">
				</router-link>
				<a :href="event.application_url" class="info__btn info__btn--gold">{{$t('event.apply')}}</a>
				<a href="https://www.booking.com/" class="info__btn info__btn--blue">{{$t('event.hotel')}} Booking<span>.com</span></a>
			</div>
		</div>
		<div class="header__download--mobile">
			<div class="container">
				<div class="row">
					<div class="col-12">
						<a :href="`/api/events/${event.id}/pdf/`" class="header__download"><img src="/static/img/download.svg" alt="">{{$t('pdf')}}<span
							class="header__download--big">  PDF</span></a>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import axios from 'axios'

	export default {
		components: {},
		data () {
			return {
				show: false,
				fav: false,
				event: {},
				url: axios.defaults.baseURL
			}
		},
		methods: {
			fetchEvent () {
				const qs = require('qs')
				const config = {
					params: {
						page: this.$route.query.page
					},
					paramsSerializer (params) {
						return qs.stringify(params, { indices: false })
					}
				}
				axios.get('/api/events/', config, {
				})
					.then(response => {
						this.event = response.data.results.find(event => {
							this.fav = event.is_favourite
							return event.id === parseInt(this.$route.params.id)
						})
					})
					.catch(error => {
						console.error(error)
					})
			},
			addFavEvent (event) {
				if (!event.is_favourite) {
					let data = {
						event: event.id
					}
					axios.post('/api/events/favourites/', data, {
						headers: {
							'accept': 'application/json'
						}
					})
						.then(response => {
							this.fetchEvent()
						})
						.catch(error => {
							console.log(error)
						})
				} else {
					axios.delete(`/api/events/favourites/${ event.id }/`, {})
						.then(response => {
							this.fetchEvent()
						})
						.catch(error => {
							console.log(error)
						})
				}
			}
		},
		created () {
			this.fetchEvent()
		}
	}
</script>

<style lang="scss" scoped>
	@import "../../styles/variables.scss";

	.header {
		padding-top: 25px;
		background-color: $green;
		&__wrapper {
			display: flex;
			justify-content: space-between;
			margin-bottom: 25px;
		}
		&__back {
			cursor: pointer;
			display: flex;
			align-items: center;
			font-family: $lato-bold;
			font-size: 16px;
			letter-spacing: 0.05em;
			text-decoration: none;
			color: $black;
			text-transform: uppercase;
		}
		&__download {
			display: flex;
			align-items: center;
			font-size: 14px;
			text-decoration: none;
			color: $black;
			&--desktop {
				@media (max-width: 991.98px) {
					display: none;
				}
			}
			&--mobile {
				@media (min-width: 992px) {
					display: none;
				}
			}
			img {
				margin-right: 15px;
			}
			&--big {
				font-family: $lato-bold;
				margin-left: 5px;
			}
		}
		&__headline {
			text-align: left;
			font-family: $lato-bold;
			font-size: 36px;
			color: #fff;
			margin: 0;
			margin-bottom: 20px;
		}
		&__rank {
			text-transform: uppercase;
			text-align: left;
			display: block;
			font-family: $lato-bold;
			font-size: 16px;
			color: #fff;
			&--regular {
				text-transform: none;
				font-family: $lato;
			}
		}
	}

	.info {
		position: relative;
		width: 265px;
		background-color: #fff;
		margin: 0 auto;
		padding: 30px 0 20px;
		&--mobile {
			display: none;
		}
		&__date {
			display: block;
			width: 100%;
			font-family: $lato-bold;
			font-size: 26px;
			margin: 0;
			margin-bottom: 30px;
			&--small {
				display: inline;
				font-size: 14px;
			}
		}
		&__headline {
			font-family: $lato;
			font-size: 13px;
			color: $gold-dark;
			text-transform: uppercase;
			margin: 0;
			margin-bottom: 15px;
		}
		&__divider {
			width: 180px;
			height: 2px;
			background-color: $gold-dark;
			margin: 0 auto;
			margin-bottom: 10px;
		}
		&__deadline {
			display: block;
			width: 100%;
			font-family: $lato-bold;
			font-size: 26px;
			color: $gold-dark;
			margin: 0;
			&--small {
				display: inline;
				font-size: 14px;
			}
		}
		&__buttons {
			position: absolute;
			bottom: -120px;
		}
		&__btn {
			cursor: pointer;
			display: flex;
			justify-content: center;
			align-items: center;
			width: 265px;
			height: 40px;
			background-color: $gold-score;
			color: #fff;
			text-decoration: none;
			font-family: $lato-bold;
			font-size: 14px;
			&--fav {
				background-color: white;
				color: $gold-score;
			}
			img {
				margin-left: 10px;
			}
			&--gold {
				background-color: $gold;
			}
			&--blue {
				background-color: #18357e;
				span {
					color: #71c6ff;
				}
			}
		}
	}

	@media (max-width: 991.98px) {
		.header {
			padding-top: 25px;
			background-color: $green;
			&__wrapper {
				display: flex;
				justify-content: space-between;
				margin-bottom: 25px;
			}
			&__back {
				cursor: pointer;
				display: flex;
				align-items: center;
				font-family: $lato-bold;
				font-size: 16px;
				letter-spacing: 0.05em;
				text-decoration: none;
				color: $black;
				text-transform: uppercase;
			}
			&__download {
				width: 100%;
				justify-content: flex-end;
				&--mobile {
					padding-top: 15px;
					background: $gray-light;
				}
			}
			&__headline {
				text-align: left;
				font-family: $lato-bold;
				font-size: 20px;
				color: #fff;
				margin: 0;
				margin-bottom: 20px;
			}
			&__rank {
				text-transform: uppercase;
				text-align: left;
				display: block;
				font-family: $lato-bold;
				font-size: 16px;
				color: #fff;
				margin-bottom: 20px;
				&--regular {
					text-transform: none;
					font-family: $lato;
				}
			}
		}

		.info {
			position: relative;
			width: 100%;
			background-color: #fff;
			margin: 0 auto;
			padding: 30px 0 20px;
			&--mobile {
				display: flex;
				flex-flow: column;
				padding-bottom: 0;
			}
			&__date {
				display: block;
				width: 100%;
				font-family: $lato-bold;
				font-size: 26px;
				margin: 0;
				margin-bottom: 30px;
				&--small {
					display: inline;
					font-size: 14px;
				}
			}
			&__headline {
				font-family: $lato;
				font-size: 13px;
				color: $gold-dark;
				text-transform: uppercase;
				margin: 0;
				margin-bottom: 15px;
			}
			&__divider {
				width: 180px;
				height: 2px;
				background-color: $gold-dark;
				margin: 0 auto;
				margin-bottom: 10px;
			}
			&__deadline {
				display: block;
				width: 100%;
				font-family: $lato-bold;
				font-size: 26px;
				color: $gold-dark;
				margin: 0;
				margin-bottom: 20px;
				&--small {
					display: inline;
					font-size: 14px;
				}
			}
			&__buttons {
				position: static;
				display: flex;
				flex-flow: column;
			}
			&__btn {
				cursor: pointer;
				display: flex;
				justify-content: center;
				align-items: center;
				width: 100%;
				height: 40px;
				background-color: $gold-score;
				color: #fff;
				text-decoration: none;
				font-family: $lato-bold;
				font-size: 14px;
				&--fav {
					background-color: white;
					color: $gold-score;
				}
				img {
					margin-left: 10px;
				}
				&--gold {
					background-color: $gold;
				}
				&--blue {
					background-color: #18357e;
					span {
						color: #71c6ff;
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Event/EventHeaderComponent.vue